import { Modal } from '@shopify/polaris';
import { memo } from 'react';

interface DiscardChangeModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
  onStay: VoidFunction;
  onLeave: VoidFunction;
}

const DiscardChangeModal = ({ isOpen, onClose, onStay, onLeave }: DiscardChangeModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size="small"
      title="Discard changes?"
      primaryAction={{
        content: 'Leave page',
        onAction: onLeave,
        destructive: true,
      }}
      secondaryActions={[
        {
          content: 'Stay',
          onAction: onStay,
        },
      ]}
    >
      <Modal.Section>You have unsaved changes, are you sure you want to discard all unsaved changes?</Modal.Section>
    </Modal>
  );
};

export default memo(DiscardChangeModal);
